import { cn } from '@/lib/utils.js';

interface EnumParamProps {
  id: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  disabled?: boolean | undefined;
  error?: string | undefined;
  required?: boolean | undefined;
}

export function EnumParam({
  id,
  value,
  options,
  onChange,
  disabled,
  error,
  required,
}: EnumParamProps) {
  return (
    <>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        required={required}
        aria-required={required === true ? true : undefined}
        aria-invalid={error !== undefined ? true : undefined}
        aria-describedby={error !== undefined ? `${id}-error` : undefined}
        className={cn(
          'flex h-10 w-full rounded-[var(--radius-input)] border px-3 py-2 text-sm',
          'bg-[var(--color-qup-bg-card-dark)] text-[var(--color-qup-text-dark)]',
          'transition-all duration-200',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-qup-primary)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          error !== undefined
            ? 'border-[var(--color-qup-error)]'
            : 'border-[var(--color-qup-border-dark)]',
        )}
      >
        {!required && <option value="">—</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error !== undefined && (
        <span
          id={`${id}-error`}
          role="alert"
          className="mt-1 block text-xs text-[var(--color-qup-error)]"
        >
          {error}
        </span>
      )}
    </>
  );
}
